<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card class="pb-3">
            <v-card-title>
                <span class="headline">Edit Day</span>
            </v-card-title>
            <v-card-text>
                <span>UID: {{ model.uid }}</span>
                <v-text-field label="Name:" v-model.trim="model.name" hide-details class="mt-3"/>
                <v-text-field label="Key:" v-model.trim="model.key" hide-details class="mt-3"/>
                <v-text-field label="Delay to start:" v-model.trim="model.latency" hide-details class="mt-3" @input="val => model.latency = parseInt(val) || 0"/>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="red " text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="green" class="white--text">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import VueTypes from "vue-types";
import {SmartOfferBundleNoviceBattlePassDay} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDay";

export default {
    name: "r-smart-offer-bundle-novice-battle-pass-day-edit-dialog",
    components: {},
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        model: VueTypes.objectOf(SmartOfferBundleNoviceBattlePassDay),
    }),
    methods: {
        show(day_model) {

            this.dialog = true;
            this.model = day_model || new SmartOfferBundleNoviceBattlePassDay();

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config!");
            }
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        }
    }
};
</script>
